"use client";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import ForgotPasswordForm from "@/app/(public)/forgot-password/ForgotPasswordForm";
import { useForgotPasswordMutation } from "@/lib/redux/api/authApi";
import { clearFieldErrors } from "@/lib/redux/slices/formSlice";

export default function ForgotPasswordPage() {
  const [formSubmitted, setFormSubmitted] = useState(false);
  
  const titleConfig = {
    text: "Forgot Password",
    className: "text-4xl font-bold text-black",
    style: {},
  };
  
  const subtitleConfig = {
    text: "Enter registered email to get verification to reset password.",
    className: "text-base font-medium text-black/45",
    style: {},
  };
  
  const [forgetPassword] = useForgotPasswordMutation();
  const dispatch = useDispatch();
  const fieldErrors = useSelector((state) => state.form.fieldErrors);
  
  const handleForgotPasswordSubmit = async (data) => {
    try {
      dispatch(clearFieldErrors());
      const response = await forgetPassword(data.email).unwrap();
      
      // Mark form as submitted to trigger the reset in the form component
      setFormSubmitted(true);
      
      toast.success(response?.message);
      if (response?.status === true) {
        Cookies.set("email", data?.email);
      }
    } catch(error) {
            toast.error(error?.data?.error);
    }
  };

  return (
    <ForgotPasswordForm
      title={titleConfig}
      subtitle={subtitleConfig}
      onSubmit={handleForgotPasswordSubmit}
      fieldErrors={fieldErrors}
      formSubmitted={formSubmitted}
      setFormSubmitted={setFormSubmitted}
    />
  );
}
